import styled from "styled-components";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { colors, zIndex } from "@sonder/ui/source/styled/theme";

export const Modal = styled.div`
  position: relative;

  @media screen and (min-width: 50rem) {
    width: 40rem;
  }
`;

export const Overlay = styled.div`
  align-items: center;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${zIndex.overlay};

  &:before {
    background: ${colors.gray1};
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0.4;
    position: fixed;
    right: 0;
    top: 0;
  }

  ${Modal} {
    background: ${colors.white};
    border-radius: 0.3rem;
    box-sizing: border-box;
    max-width: 90vw;
    padding: 1.5rem;
  }
`;

export const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ModalTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: normal;
  margin: 0;
`;

export const ModalClose = styled(CircleButton)`
  margin-left: auto;
`;
